export const formatAddressLine1 = (
  unit: string,
  building: string,
  street: string,
): string => {
  if (unit && unit.trim() !== '') {
    return `${unit} ${building} ${street}`;
  } else {
    return `${building} ${street}`;
  }
};
